import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
const TRANSITION_DURATION_MS = 200;
const TRANSITION_EASING = 'ease-out';
/**
 * Animates the wrapper's size to match its children's intrinsic size as
 * content changes. Unlike Motion.Expand, this is not gated on a visibility
 * boolean — it always renders, and only the size animates as content swaps.
 */
export function MotionResize({ children, className, direction = 'vertical', }) {
    const contentRef = useRef(null);
    const [contentSize, setContentSize] = useState(null);
    const isHorizontal = direction === 'horizontal';
    const sizeProperty = isHorizontal ? 'width' : 'height';
    useLayoutEffect(() => {
        const element = contentRef.current;
        if (!element)
            return;
        const updateSize = () => {
            setContentSize(isHorizontal ? element.scrollWidth : element.scrollHeight);
        };
        updateSize();
        const resizeObserver = new ResizeObserver(updateSize);
        resizeObserver.observe(element);
        return () => resizeObserver.disconnect();
    }, [isHorizontal]);
    // Skip the transition for the first applied measurement so the wrapper
    // renders at its natural size on mount instead of transitioning from 0.
    const isMeasured = contentSize !== null;
    const [hasInitialSizeApplied, setHasInitialSizeApplied] = useState(false);
    useLayoutEffect(() => {
        if (isMeasured && !hasInitialSizeApplied)
            setHasInitialSizeApplied(true);
    }, [isMeasured, hasInitialSizeApplied]);
    return (_jsx("div", { style: {
            overflow: 'hidden',
            [sizeProperty]: contentSize ?? undefined,
            transition: hasInitialSizeApplied
                ? `${sizeProperty} ${TRANSITION_DURATION_MS}ms ${TRANSITION_EASING}`
                : undefined,
        }, className: className, children: _jsx("div", { ref: contentRef, children: children }) }));
}
//# sourceMappingURL=MotionResize.js.map